import { AddSickCertForm } from "components/AddSickCertForm/AddSickCertForm";
import { Dialog } from "components/ui/Dialog";
import { useSickCertDetail } from "features/communications/hooks/useSickCertDetail";

import styles from "./SickCertsSection.module.css";

export const EditSickCertModal = ({
  open,
  sickCertId,
  patientId,
  onClose,
  refetchList,
}) => {
  const {
    data: cert,
    isLoading,
    refetch: refetchDetail,
  } = useSickCertDetail(sickCertId);

  const handleSaved = () => {
    refetchList?.();
    refetchDetail();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={cert?.name || "Sick Certificate"}
      width={900}
      minHeight={600}
    >
      {isLoading ? (
        <p className={styles.loading}>Loading…</p>
      ) : cert ? (
        <AddSickCertForm
          patientId={patientId}
          consultationId={cert.consultationId}
          initialData={cert}
          isReadOnly={false}
          showNewCertOption={false}
          refetchSickCerts={handleSaved}
        />
      ) : (
        <p className={styles.loading}>Sick cert not found.</p>
      )}
    </Dialog>
  );
};
